import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { user, loading, accessLoading, hasPortalAccess } = useAuth();

  // Show loading state while checking authentication
  if (loading || accessLoading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#e5e3e3',
        fontFamily: "'Plus Jakarta Sans', sans-serif"
      }}>
        <div style={{
          textAlign: 'center',
          color: '#6B7280'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #E5E7EB',
            borderTop: '4px solid #3399FF',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }} />
          <p style={{ margin: 0, fontSize: '16px' }}>Laden...</p>
        </div>
      </div>
    );
  }

  // Redirect to signup if not authenticated
  if (!user) {
    return <Navigate to="/signup" replace />;
  }

  if (!hasPortalAccess) {
    const pay = new URLSearchParams(location.search).get('payment');
    const billingTo = pay === 'success' ? '/billing?payment=success' : '/billing';
    return <Navigate to={billingTo} replace />;
  }

  // User is authenticated, render the protected component
  return children;
};

export default ProtectedRoute;

